export const withFullTranslationKey = (translationKey: string) => {
  return `infringement_claim_form:${translationKey}`;
};

export const CLAIMANT_DETAILS = {
  fields: {
    CLAIMANT_FIRST_NAME: 'claimantFirstName',
    CLAIMANT_LAST_NAME: 'claimantLastName',
    CLAIMANT_COMPANY_NAME: 'claimantCompanyName',
    CLAIMANT_ADDRESS: 'claimantAddress',
    CLAIMANT_PHONE: 'claimantPhone',
    CLAIMANT_EMAIL: 'claimantEmail',
    CLAIMANT_MORE_INFO: 'claimantMoreInfo',
    CLAIMANT_COUNTRY_CODE: 'claimantCountryCode',
    CLAIMANT_USERID: 'userId',
  },
  labels: {
    CLAIMANT_FIRST_NAME: 'claimant_first_name_label',
    CLAIMANT_LAST_NAME: 'claimant_last_name_label',
    CLAIMANT_COMPANY_NAME: 'claimant_company_name_label',
    CLAIMANT_ADDRESS: 'claimant_address_label',
    CLAIMANT_EMAIL: 'claimant_email_label',
    CLAIMANT_PHONE: 'claimant_phone_label',
    CLAIMANT_MORE_INFO: 'claimant_more_info_label',
  },
};

export const CONTENT_DETAILS = {
  fields: {
    REPORTED_CONTENT_URIS: 'productUris',
    REPORTED_CONTENT_TYPE: 'contentType',
    COMMON_ASSET_TYPE: 'commonAssetType',
    REPORTED_CONTENT_DESCRIPTION: 'contentDescription',
    CLAIM_TYPE: 'claimType',
    ASSOCIATED_CONTENT: 'associatedContent',
    ENTITIES: 'entities',
    COUNTRY: 'country',
    RELEVANT_LAW: 'relevantLaw',
  },
  labels: {
    REPORTED_CONTENT_URIS: 'content_uris_label',
    REPORTED_CONTENT_ONE_URI: 'content_one_uri_label',
    REPORTED_CONTENT_DESCRIPTION: 'case_description_label',
    REPORTED_CONTENT_DESCRIPTION_NON_IP: 'case_description_label_non_ip',
    COUNTRY: 'country_label',
    RELEVANT_LAW: 'relevant_law_label',
  },
  translationPrefixes: {
    REPORTED_CONTENT_TYPE: 'content_type',
    CLAIM_TYPE: 'claim_type',
    COUNTRY: 'country',
  },
};

export const CLAIM_DETAILS = {
  fields: {
    CLAIMANT_RELATIONSHIP_RIGHTSHOLDER: 'relationshipWithRightsholder',
    RIGHTSHOLDER_NAME: 'rightsholderName',
    RIGHTSHOLDER_PHONE_FAX: 'rightsholderPhoneFax',
    RIGHTSHOLDER_EMAIL: 'rightsholderEmail',
    RIGHTSHOLDER_ROLE: 'claimantRelationshipDetailed',
    CLAIM_COPYRIGHT: 'copyrightType',
    CLAIM_COPYRIGHT_INFO: 'copyrightDescription',
    CLAIM_TERRITORIES: 'territories',
    CLAIM_OTHER_TERRITORIES: 'otherTerritories',
    CLAIM_OTHER: 'claimTypeOther',
    CLAIM_TRADEMARK_NAME: 'trademarkName',
    CLAIM_TRADEMARK_NO: 'trademarkRegistrationNumbers',
    CLAIM_TRADEMARK_STATUS: 'trademarkStatus',
  },
  labels: {
    RIGHTSHOLDER_NAME: 'rightsholder_name',
    RIGHTSHOLDER_PHONE_FAX: 'rightsholder_phone_fax',
    RIGHTSHOLDER_EMAIL: 'rightsholder_email',
    RIGHTSHOLDER_ROLE_INPUT_LABEL: 'rightsholder_role_input_label',
    CLAIM_COPYRIGHT_INFO: 'claim_type_copyright_info',
    CLAIM_COPYRIGHT_INFO_UMG: 'claim_type_copyright_info_umg',
    CLAIM_TERRITORIES: 'territories',
    CLAIM_OTHER_TERRITORIES: 'other_territories',
    CLAIM_OTHER_PREFIX: 'claim_type_other',
    CLAIM_TRADEMARK_NO: 'trademark_no',
    CLAIM_TRADEMARK_NAME: 'trademark_name',
  },
  translationPrefixes: {
    CLAIM_COPYRIGHT: 'claim_type_copyright',
    CLAIM_TRADEMARK_STATUS: 'trademark_status',
    CLAIMANT_RELATIONSHIP_RIGHTSHOLDER: 'your_relationship_with_rightsholder',
    RIGHTSHOLDER_ROLE: 'rightsholder_role', // Custom prefix, since otherwise the option "label" is in conflict with the label of the select input.
  },
};

export const CONFIRMATION_DETAILS = {
  fields: {
    VERIFICATION_CODE: 'verificationCode',
    LEGAL_BELIEF: 'legalCheckboxBelief',
    LEGAL_ACCURATE: 'legalCheckboxAccurate',
    LEGAL_CONTACT: 'legalCheckboxContact',
    LEGAL_MISUSE: 'legalCheckboxMisuse',
    LEGAL_UMG: 'legalCheckboxUmg',
  },
  labels: {
    VERIFICATION_CODE: 'verification_code_label',
    LEGAL_BELIEF_LABEL: 'legal_checkbox_belief',
    LEGAL_ACCURATE_LABEL: 'legal_checkbox_accurate',
    LEGAL_CONTACT_LABEL: 'legal_checkbox_contact',
    LEGAL_MISUSE_LABEL: 'legal_checkbox_misuse',
    LEGAL_UMG_LABEL: 'legal_checkbox_umg',
  },
};

export const OPTIONS_TRADEMARK_STATUS_LIST = ['registered', 'unregistered', 'unregistered_pending'];

export const OPTIONS_CLAIMANT_RELATIONSHIP_RIGHTSHOLDER = {
  SELF: 'rightsholder',
  OTHER: 'authorized_agent',
};

export const OPTIONS_RIGHTSHOLDER_ROLE = {
  OTHER: 'other',
  MANAGER: 'manager',
  LABEL: 'label',
  PUBLISHER: 'publisher',
  ATTORNEY: 'attorney',
  COLLECTING_SOCIETY: 'collecting_society',
  DISTRIBUTOR: 'distributor',
};

export const OPTIONS_RIGHTSHOLDER_ROLE_LIST = Object.values(OPTIONS_RIGHTSHOLDER_ROLE);

export const OPTIONS_CLAIMANT_RELATIONSHIP_RIGHTSHOLDER_LIST = Object.values(
  OPTIONS_CLAIMANT_RELATIONSHIP_RIGHTSHOLDER,
);

export const OPTIONS_CLAIM_TYPE = {
  COPYRIGHT: 'copyright',
  TRADEMARK: 'trademark',
  PUBLICITY_LIKENESS: 'publicity_likeness',
  OTHER: 'other',
};
export const OPTIONS_CLAIM_TYPE_LIST = Object.values(OPTIONS_CLAIM_TYPE);

export const TERRITORY_OTHER = 'other';
export const TERRITORY_WORLDWIDE = 'worldwide';
const TERRITORY_UNITED_STATES = 'united_states';
const TERRITORY_EUROPEAN_UNION = 'european_union';

export const TERRITORY_LIST_GENERIC = [TERRITORY_WORLDWIDE, TERRITORY_OTHER];
export const TERRITORY_LIST_TRADEMARK = [TERRITORY_UNITED_STATES, TERRITORY_EUROPEAN_UNION, TERRITORY_OTHER];

export const RUSSIAN_MARKET_LIST = ['ru-ru', 'ru-en'];
